
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import "react-toastify/dist/ReactToastify.css";
import Footer from '../components/Footer';

const Layout = () => {
  return ( 
    <div id="app">
      <Navbar />
      <Outlet />
      <Footer />
    </div>
  );
}

export default Layout;